"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var COLUMNS = 12;
var columnSizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'auto', 'fill'];
var breakpoints = ['xs', 'sm', 'md', 'lg', 'xlg'];
var Column = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.xs, xs = _b === void 0 ? 'fill' : _b, sm = _a.sm, md = _a.md, lg = _a.lg, xlg = _a.xlg, rest = tslib_1.__rest(_a, ["className", "children", "xs", "sm", "md", "lg", "xlg"]);
    return ((0, jsx_runtime_1.jsx)("div", tslib_1.__assign({ ref: ref, className: (0, houston_styles_1.cx)(className, 'hst-grid-column', xs && "hst-grid-column-xs-".concat(xs), sm && "hst-grid-column-sm-".concat(sm), md && "hst-grid-column-md-".concat(md), lg && "hst-grid-column-lg-".concat(lg), xlg && "hst-grid-column-xlg-".concat(xlg)) }, rest, { children: children })));
});
/**
 * @deprecated Use Grid from Antd
 * https://ant.design/components/grid/
 */
exports.default = (0, houston_styles_1.default)(Column, { label: 'hst-grid-column' })(function (_a) {
    var theme = _a.theme;
    return breakpoints.map(function (breakpoint) {
        var cssSize = columnSizes.map(function (size) { return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        &.hst-grid-column-", "-", " {\n          flex-basis: ", ";\n          flex: ", ";\n        }\n      "], ["\n        &.hst-grid-column-", "-", " {\n          flex-basis: ", ";\n          flex: ", ";\n        }\n      "])), breakpoint, size, typeof size === 'string' ? 'auto' : "".concat((size / COLUMNS) * 100, "%"), size === 'fill' ? 1 : null); });
        if (breakpoint === 'xs') {
            return cssSize;
        }
        return (0, houston_styles_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      ", " {\n        ", "\n      }\n    "], ["\n      ", " {\n        ", "\n      }\n    "])), theme.breakpoints.up(breakpoint), cssSize);
    });
});
var templateObject_1, templateObject_2;
